import React, {Suspense, useEffect, useState} from "react";
import ErrorBoundary from "../../utils/ErrorBoundary";
import {IItemContent} from "@connox/typescript-library";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {paCustomerId} from "./RecommendationsPortal";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import SwiperConstruct, {BreakpointType} from "./SwiperConstruct";

const BasketRecommendationsSwiperComponent: React.FC = () => {
  const [items, setItems] = useState<IItemContent[]>([]);
  const {customer} = useCustomerSelector();
  const context = useUnsafeCartContext();
  const {t} = useTranslation();

  useEffect(() => {
    // No cart at all
    if (!isCart(context)) {
      return;
    }
    const itemPositions = context.cart.positions.filter(
      (pos) => pos.type === "Item" && !!pos.item && !!pos.reference?.itemId,
    );
    // Existing cart has no valid items
    if (!itemPositions.length) {
      return;
    }
    let paUrl = paMainUrl + "Cart?";
    const customerId = paCustomerId();
    if (customerId) {
      paUrl += `customerId=${customerId}&`;
    }

    itemPositions.forEach((pos, index) => {
      if (index > 0) {
        paUrl += "&";
      }
      paUrl += `items[${index}]=${pos.reference?.itemId ?? ""}`;
    });
    paUrl += "&filterOutOfStock=false";
    void retrieveItemContent(paUrl, customer).then(setItems);
  }, []);

  if (!items.length) {
    return null;
  }

  const breakpoints: BreakpointType = {
    768: {
      slidesPerView: 3.5
    },
    941: {
      slidesPerView: 5
    }
  };

  return (
    <SwiperConstruct
      items={items}
      title={t("product.recommendationsForYou")}
      breakpoints={breakpoints}
      isCartSwiper={true}
    />
  );
};

const BasketRecommendationsSwiper: React.FC = () => {
  return (
    <ErrorBoundary fallback={null} occurrence="BasketRecommSwiper">
      <Suspense fallback={null}>
        <BasketRecommendationsSwiperComponent />
      </Suspense>
    </ErrorBoundary>
  );
};

export default BasketRecommendationsSwiper;
